import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { MpsUserService } from '../../mps/services/mps-user.service';
import { MpsRoleHelper } from '../helpers/mps-role.helper';
import { MpsUser } from '../models/mps-user.model';

const BACK_OFFICE_ALLOWED_ROLES = [
  MpsRoleHelper.SUPER_ADMIN,
  MpsRoleHelper.CHEF_REGION,
  MpsRoleHelper.CHEF_SECTEUR,
  MpsRoleHelper.GERANT,
];

export const BackOfficeGuard = () => {
  const router = inject(Router);
  const userService = inject(MpsUserService);
  const loggedInUser = userService.getUser();

  if (!loggedInUser) {
    return router.navigateByUrl('/form');
  }

  const user = new MpsUser(loggedInUser);
  const hasAccess = user.role && BACK_OFFICE_ALLOWED_ROLES.includes(user.role.code.toUpperCase());
  return hasAccess ? true : router.navigateByUrl('/form');
};
